import { FormControl, RadioGroup, FormControlLabel, Radio, Switch } from '@material-ui/core';
import DropdownFilter from 'components/DropdownFilter';
import LotsDropdown from 'components/SharedDropdowns/LotsDropDown';
import { TenantNameResolver } from 'features/saasManagement/TenantNameResolver/TenantNameResolver';
import PricingCalculator from './PricingCalculator/PricingCalculator';

export const LOT_OPTIONS = {
    SPECIFIC_LOTS: 'specific-lots',
    ALL_LOTS: 'all-lots',
    ALL_TENANT_LOTS: 'all-tenant-lots',
    ALL_PMF_LOTS: 'all-pmf-lots',
};

export const PRICING_FIELDS = {
    CLIENT: 1,
    VENDOR: 2,
    LOT_OPTIONS: 3,
    LOT_TOGGLE: 4,
    LOTS: 5,
    VEHICLE_TYPES: 6,
    PRICE: 7
};

export const pricingFieldConfig = {
    [PRICING_FIELDS.CLIENT]: {
        name: 'Client',
        component: (value, values, onChange) => (
            <DropdownFilter
                title="Client"
                value={value}
                onSelect={onChange}
                values={values}
                multiple={false}
                showEmpty
                required
            />
        )
    },
    [PRICING_FIELDS.VENDOR]: {
        name: 'Vendor',
        component: (value, values, onChange) => (
            <DropdownFilter
                title="Vendors"
                value={value}
                onSelect={onChange}
                values={values}
                multiple={true}
                showEmpty={false}
                required
            />
        )
    },
    [PRICING_FIELDS.LOT_OPTIONS]: {
        name: 'Lot Selection',
        component: (value, onChange) => (
            <FormControl>
                <RadioGroup value={value} onChange={onChange} aria-labelledby="lot-options-radio-group" name="lot-options-radio-group" row>
                    <FormControlLabel value={LOT_OPTIONS.ALL_LOTS} control={<Radio />} label="All Lots" />
                    <FormControlLabel value={LOT_OPTIONS.ALL_PMF_LOTS} control={<Radio />} label={<TenantNameResolver startText="All" endText="Lots" />} />
                    <FormControlLabel value={LOT_OPTIONS.SPECIFIC_LOTS} control={<Radio />} label="Specific Lots" />
                </RadioGroup>
            </FormControl>
        )
    },
    [PRICING_FIELDS.LOT_TOGGLE]: {
        name: <TenantNameResolver startText="Include Non" endText="Lots" />,
        component: (checked, onChange, label) => (
            <FormControlLabel
                control={
                    <Switch
                        color="primary"
                        inputProps={{ 'aria-label': 'controlled' }}
                        onChange={onChange}
                        checked={checked}
                    />
                }
                label={label}
            />
        )
    },
    [PRICING_FIELDS.LOTS]: {
        name: 'Lots',
        component: (value, lots, onChange, ownedByTenant, clientId) => (
            <LotsDropdown
                title="Lots"
                identifier='lots'
                values={lots}
                onSelect={onChange}
                value={value}
                showEmpty={true}
                multiple={true}
                required={true}
                ownedByTenant={ownedByTenant}
                clientId={clientId}
            />
        )
    },
    [PRICING_FIELDS.VEHICLE_TYPES]: {
        name: 'Vehicle Types',
        component: (value, values, onChange) => (
            <DropdownFilter
                title="Vehicle Types"
                value={value}
                onSelect={onChange}
                values={values}
                multiple={true}
                showEmpty={false}
            />
        )
    },
    [PRICING_FIELDS.PRICE]: {
        name: 'Price',
        component: (clientId, value, onChange, pricingType, materials, isDefaultClientPricing = false) => (
            <PricingCalculator
                clientId={clientId}
                value={value}
                onChange={onChange}
                pricingType={pricingType}
                materials={materials}
                isDefaultClientPricing={isDefaultClientPricing}
            />
        )
    }
};

